import { useState } from 'react'

export function JsonViewer({ data, title }: { data: any; title?: string }) {
  const [collapsed, setCollapsed] = useState(false)
  const [copied, setCopied] = useState(false)
  const jsonString = data !== undefined ? JSON.stringify(data, null, 2) : 'undefined'

  const handleCopy = (e: React.MouseEvent) => {
    e.stopPropagation()
    navigator.clipboard.writeText(jsonString)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <div className="json-viewer">
      <div className="json-viewer-header" onClick={() => setCollapsed(!collapsed)}>
        <span className="json-viewer-title">{title || 'JSON Payload'}</span>
        <div className="json-viewer-actions">
          <button className="btn-action-small" onClick={handleCopy}>
            {copied ? 'Copied!' : 'Copy'}
          </button>
          <button className="btn-action-small btn-toggle">
            {collapsed ? 'Expand' : 'Collapse'}
          </button>
        </div>
      </div>
      {!collapsed && (
        <div className="json-viewer-body">
          <pre className="monospace-code">
            <code>{jsonString}</code>
          </pre>
        </div>
      )}
    </div>
  )
}
